module.exports = __webpack_public_path__ + "img/jugando.png.7d3a06e6.webp";